module.exports = __webpack_public_path__ + "static/media/COSEP.4079d280.png";